import { Controller } from 'stimulus';

export default class extends Controller {
    /**
     *
     */
    connect() {
        try {
          $(this.element.querySelectorAll('a')).popover();
        } catch (e) {

        }
    }

    /**
     *
     * @param event
     */
    trigger(event) {
        event.preventDefault();
        $(this.element).popover('toggle');
    }
}
